/**
 * Single source of truth for all AI Workspace layout and timing constants.
 * Nothing in this module should contain magic numbers — import from here.
 */

/** Maximum pixel width of the fullscreen floating workspace. */
export const AI_WORKSPACE_MAX_WIDTH_PX = 1700;

/** Maximum viewport-width percentage for the fullscreen workspace (caps the width on ultrawide monitors). */
export const AI_WORKSPACE_MAX_WIDTH_VW = 92;

/** Maximum viewport-height percentage for the fullscreen workspace. */
export const AI_WORKSPACE_MAX_HEIGHT_VH = 92;

/** Size of the `AiOrb` used in the rail header and small inline contexts. */
export const AI_ORB_SIZE_SMALL_PX = 28;

/** Size of the `AiOrb` used in the `WelcomeLayout` hero. */
export const AI_ORB_SIZE_LARGE_PX = 96;

/**
 * Milliseconds of stream inactivity before the client aborts with an
 * "interrupted" error. 30 s covers slow cold-start responses from hosted
 * LLM providers without being excessively lenient.
 */
export const AI_STREAM_IDLE_TIMEOUT_MS = 30_000;

/**
 * Exponential-backoff delays for automatic network-level stream retries.
 * Applied in order; after all delays are exhausted the error surfaces.
 * MUST NOT be used for 4xx / AbortError — those fail fast immediately.
 */
export const AI_STREAM_RETRY_DELAYS_MS = [1_000, 2_000, 4_000] as const;

/** Maximum number of recently-used prompt IDs shown in `RecentPromptChips`. */
export const RECENT_PROMPT_CHIP_LIMIT = 4;

/** localStorage key for persisting AI workspace UI preferences. */
export const AI_WORKSPACE_STORAGE_KEY = 'ai_workspace_v1';
